angular.module('autoremind.communications')
    .directive('communicationsTargetBirthday', function () {
    return {
        restrict: 'E',
        scope: true,
        templateUrl: 'app/communication/forms/communications-target-birthday.html',
        link: function (scope) {
            scope.isAppointmentSince = false;
            scope.appointmentSince = [
                { label: '3 months', value: 91 },
                { label: '6 months', value: 182 },
                { label: '9 months', value: 275 },
                { label: '1 year', value: 365 },
                { label: '1½ years', value: 455 },
                { label: '2 years', value: 730 },
                { label: '2½ years', value: 912 },
                { label: '3 years', value: 1095 }
            ];
        }
    };
});
//# sourceMappingURL=communications-target-birthday.js.map